module.exports = __webpack_public_path__ + "img/letter.e1167aa0.png";